import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
import { NAMESPACE as PARENT_NAMESPACE } from "../constants";
export const NAMESPACE = "content";
export const FULL_NAMESPACE = createNamespace(PARENT_NAMESPACE, NAMESPACE);
export { PARENT_NAMESPACE as PAGE_NAMESPACE };
const COMMAND_ATTR = "data-content-command";
export const sendToGraphButtonAttrs = { [COMMAND_ATTR]: "SendToGraph" };
export const sendToGraphSelector = `[${COMMAND_ATTR}='SendToGraph']`;
export const postBlockIdPrefix = "contentPostBlock_";
export const NODE_ID_ATTR = "data-node-id";
export const NODE_GROUP_ID_ATTR = "data-node-group-id";
